/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
    headingType?: "Order" | "Quote";
}

export interface CardListHeadingStyles {
    orderSummaryHeadingContainer?: GridContainerProps;
    cardListHeading?: TypographyPresentationProps;
    containerGridItem?: GridItemProps;
    PriceGridItem?: GridItemProps;
    cardListGridItem?: InjectableCss;
    StandardItem?: GridItemProps;
    RequestByItem?: GridItemProps;
    PurchaseDateGridItem?: GridItemProps;
    StatusGridItem?: GridItemProps;
    PaymentMethodGridItem?: GridItemProps;
}

export const cardListHeadingStyles: CardListHeadingStyles = {
    orderSummaryHeadingContainer: {
        css: css`
            background-color: #f2f2f2;
            color: #666666;
            font-size: 16px;
            padding: 9px 16px;
            font-weight: 700;
            display: flex;
            align-items: center;
            max-width: initial !important;
            width: initial !important;

            > div {
                flex-wrap: nowrap !important;
            }

            > div > div {
                min-width: 145px;
            }
        `,
    },
    cardListHeading: {
        size: 18,
        weight: 700,
        lineHeight: "28px",
        color: "#333333",
        css: css`
            margin-bottom: 0;
        `,
    },
    cardListGridItem: {
        css: css`
            padding: 16px 16px 16px 0;
        `,
    },
    containerGridItem: {
        css: css`
            padding: 0;
        `,
    },
    PurchaseDateGridItem: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        padding: 15px 10px 15px 10px;
                    `,
                    css`
                        padding: 15px 10px 15px 10px;
                    `,
                ]);
            }}
        `,
    },
    PriceGridItem: {
        css: css`
            justify-content: flex-end;

            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        padding: 15px 40px 15px 5px;
                    `,
                    css`
                        padding: 15px 40px 15px 5px;
                    `,
                ]);
            }}
        `,
    },
    StandardItem: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        padding: 15px 40px 15px 5px;
                    `,
                    css`
                        padding: 15px 40px 15px 5px;
                    `,
                ]);
            }}
        `,
    },
    RequestByItem: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        padding: 15px 40px 15px 0;
                    `,
                    css`
                        padding: 15px 40px 15px 0;
                    `,
                ]);
            }}
        `,
    },
    PaymentMethodGridItem: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        padding: 15px 23px 15px 15px;
                    `,
                    css`
                        padding: 15px 23px 15px 15px;
                    `,
                ]);
            }}
        `,
    },
    StatusGridItem: {
        css: css`
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        padding: 15px 23px 15px 15px;
                    `,
                    css`
                        padding: 15px 23px 15px 15px;
                    `,
                ]);
            }}
        `,
    },
};

const styles = cardListHeadingStyles;

const CardListHeading: React.FunctionComponent<OwnProps> = ({ headingType }) => {
    return (
        <>
            <GridItem width={12} {...styles.containerGridItem}>
                <GridContainer {...styles.orderSummaryHeadingContainer}>
                    {headingType === "Order" && (
                        <>
                            <GridItem width={2}>{translate("Order number")}</GridItem>
                            <GridItem width={2}>{translate("Product")}</GridItem>
                            <GridItem width={2} {...styles.PurchaseDateGridItem}>
                                {translate("Purchase date")}
                            </GridItem>
                            <GridItem width={2} {...styles.PriceGridItem}>
                                {translate("Price")}
                            </GridItem>
                            <GridItem width={2} {...styles.PaymentMethodGridItem}>
                                {translate("Payment")}
                            </GridItem>
                            <GridItem width={3} {...styles.StatusGridItem}>
                                {translate("Status")}
                            </GridItem>
                            <GridItem width={3}>{translate("Purchased by")}</GridItem>
                        </>
                    )}
                    {headingType === "Quote" && (
                        <>
                            <GridItem width={2}>{translate("Request number")}</GridItem>
                            <GridItem width={2} {...styles.StandardItem}>
                                {translate("Product")}
                            </GridItem>
                            <GridItem width={2} {...styles.StandardItem}>
                                {translate("Quote date")}
                            </GridItem>
                            <GridItem width={3} {...styles.StandardItem}>
                                {translate("Status")}
                            </GridItem>
                            <GridItem width={3} {...styles.RequestByItem}>
                                {translate("Requested by")}
                            </GridItem>
                        </>
                    )}
                </GridContainer>
            </GridItem>
        </>
    );
};

export default CardListHeading;
